import React from 'react';
import styles from './SendMessageStep.module.css';
import { EmailSetup } from './EmailSetup';
import { SMSSetup } from './SMSSetup';
import { MergeFields } from './MergeFields';

type SendMessageFormField = 'subject' | 'previewText' | 'html' | 'css' | 'text';

interface SendMessageFormProps {
  subject: string;
  previewText: string;
  html: string;
  css: string;
  text: string;
  onChange: (field: SendMessageFormField, value: string) => void;
  onOpenStripoEditor: () => void;
}

export const SendMessageForm: React.FC<SendMessageFormProps> = ({
  subject,
  previewText,
  html,
  css,
  text,
  onChange,
  onOpenStripoEditor,
}) => (
  <form className={styles.form}>
    <EmailSetup
      subject={subject}
      previewText={previewText}
      html={html}
      css={css}
      onSubjectChange={value => onChange('subject', value)}
      onPreviewTextChange={value => onChange('previewText', value)}
      onOpenEditor={onOpenStripoEditor}
    />
    <SMSSetup defaultValue={text} onChange={value => onChange('text', value)} />
    <MergeFields />
  </form>
);
